import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { PRODUCT_ROUTE } from '../../utils/const'; // путь должен быть корректным

const ProductCardSearch = ({ product }) => {
    const navigate = useNavigate();
    return (
        <Card className="h-100 shadow-sm">
            {product.image && (
                <Card.Img
                    variant="top"                    
                    src={`${process.env.REACT_APP_API_URL_PROD}img/${product.image}`}
                    alt={product.name}
                    style={{ objectFit: 'cover', height: '200px' }}
                />
            )}
            <Card.Body className="d-flex flex-column">
                <Card.Title className="fs-6">{product.name}</Card.Title>
                {product.price && (
                    <Card.Text className="fw-bold text-primary">
                                {product.isSale ? (
                                  <>
                                    <span className="basic_price text-danger me-2">{product.salePrice}₽</span>
                                    <span className="text-secondary text-decoration-line-through">{product.price}₽</span>
                                  </>
                                ) : (
                                  <span className="basic_price">{product.price}₽</span>
                                )}
                    </Card.Text>
                )}
                <Button variant="outline-dark" className="mt-auto"
                    onClick={() => navigate(`${PRODUCT_ROUTE}/${product.id}`)}
                     >
                    Подробнее
                </Button>
            </Card.Body>
        </Card>
    );
};

export default ProductCardSearch;
